import React, { useState } from "react";
import { CardView, Select, SelectOption } from "../../../../controls";
import BarChartView from "../Other/BarChartView";
import "./CardStyles.scss";

const ECGReportsCardHospitalAdmin = (props) => {
  const chartData =
    props.data.length > 0 ? props.data : [{ label: "", count: 0 }];

  return (
    <div className="hospital-admin-cards-wrapper right-card">
      <CardView
        extraStyle="ecg-records-card-control"
        bodyStyle={{ height: "320px" }}
      >
        <div className="card-header">
          <div className="title">ECG reports by Centers</div>
          <div className="dropdown-option-wrapper">
            <SelectOption
              options={props.hospitalAdminDropdownOptions}
              placeholder={"Select"}
              isSearchable={false}
              value={props.hospitalAdminEcgReportsFilterSelected}
              onChange={(val) => {
                console.log("SELECT : ", val);
                props.onHospitalAdminEcgReportsFilterChange(val);
              }}
            />
          </div>
        </div>

        <div className="info-wrapper">
          <div className="bar-chart-wrapper">
            <BarChartView dataSet={chartData} theme="blue" />
          </div>
        </div>
      </CardView>
    </div>
  );
};

export default ECGReportsCardHospitalAdmin;
